import { Box, Center, Grid } from '@lojinha/design-system'
import React, { FC } from 'react'
import { MarketableKind } from '@lojinha/palantir'
import { CarouselDisplay } from '../../../components/carousel-display'
import { itemsMock } from '../../../components/carousel-display/mock'
import { OriginList } from '../../../modules/display/types'
import {
  onArrowSlideClick,
  onItemClick,
  onRenderItem,
} from '../../../modules/display/logic'
import { t } from '../../../dictionary'

type CarouselProps = {
  id: string
  kind: MarketableKind
}

export const Carousel: FC<CarouselProps> = ({ id, kind }) => {
  //TODO: remove mock
  const items = itemsMock.slice(0, 4)

  return (
    <Box paddingTop="x16" paddingBottom="x64">
      <Center>
        <Grid
          gridTemplateColumns={[
            'repeat(24, 1fr)',
            'repeat(12, 1fr)',
            'repeat(12, 1fr)',
          ]}
        >
          <Grid
            gridColumn={['1 / 25', '1 / 13', '1 / 13']}
            display="block"
            htmlAttrs={{ style: { maxWidth: '100%' } }}
          >
            <CarouselDisplay
              name={t.youWillAlsoLike}
              id={id}
              items={items}
              originList={OriginList.CATEGORY}
              onArrowSlideClick={onArrowSlideClick}
              onRenderItem={onRenderItem}
              onItemClick={onItemClick}
              showLastCard={false}
              kind={kind}
            />
          </Grid>
        </Grid>
      </Center>
    </Box>
  )
}
